import { Icon } from '@iconify/react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    produk: [
      { name: 'Rekrutmen', href: '#' },
      { name: 'Payroll', href: '#' },
      { name: 'Absensi', href: '#' },
      { name: 'Analytics', href: '#' },
      { name: 'AI Screening', href: '#' },
    ],
    perusahaan: [
      { name: 'Tentang Kami', href: '#tentang' },
      { name: 'Lowongan Kerja', href: '#loker' },
      { name: 'Blog', href: '#' },
      { name: 'Kontak', href: '#' },
    ],
    bantuan: [
      { name: 'Help Center', href: '#' },
      { name: 'Dokumentasi API', href: '#' },
      { name: 'Status', href: '#' },
      { name: 'Kebijakan Privasi', href: '#' },
      { name: 'Syarat & Ketentuan', href: '#' },
    ],
  };

  const socialMedia = [
    { name: 'LinkedIn', icon: 'mdi:linkedin', href: '#' },
    { name: 'Instagram', icon: 'mdi:instagram', href: '#' },
    { name: 'Twitter', icon: 'mdi:twitter', href: '#' },
    { name: 'YouTube', icon: 'mdi:youtube', href: '#' },
    { name: 'Facebook', icon: 'mdi:facebook', href: '#' },
  ];

  return (
    <footer className="bg-gray-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">

        {/* ===== MAIN FOOTER CONTENT ===== */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">

          {/* ===== BRAND SECTION ===== */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg gradient-btn flex items-center justify-center">
                <Icon icon="mdi:hexagon-multiple" className="text-white text-lg" />
              </div>
              <span className="text-xl font-bold text-white">ZENTRA</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 max-w-sm">
              Platform HR Management System terlengkap untuk membantu perusahaan Indonesia
              mengelola SDM dengan lebih cerdas, cepat, dan terukur.
            </p>

            {/* ===== SOCIAL MEDIA ===== */}
            <div className="flex items-center gap-3">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-9 h-9 rounded-lg bg-gray-800 hover:bg-zentra-600 flex items-center justify-center transition-colors duration-300 group"
                  aria-label={social.name}
                >
                  <Icon
                    icon={social.icon}
                    className="text-gray-400 group-hover:text-white text-lg transition-colors duration-300"
                  />
                </a>
              ))}
            </div>
          </div>

          {/* ===== PRODUK LINKS ===== */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Produk</h4>
            <ul className="space-y-2.5">
              {footerLinks.produk.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ===== PERUSAHAAN LINKS ===== */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Perusahaan</h4>
            <ul className="space-y-2.5">
              {footerLinks.perusahaan.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ===== BANTUAN LINKS ===== */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Bantuan</h4>
            <ul className="space-y-2.5">
              {footerLinks.bantuan.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* ===== BOTTOM BAR ===== */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">

          {/* ===== COPYRIGHT ===== */}
          <p className="text-xs text-gray-500">
            © {currentYear} Zentra. All rights reserved.
          </p>

          {/* ===== BADGES ===== */}
          <div className="flex items-center gap-6">
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <Icon icon="mdi:shield-check" className="text-emerald-500 text-sm" />
              ISO 27001 Certified
            </span>
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <Icon icon="mdi:server" className="text-zentra-400 text-sm" />
              Data Hosted in Indonesia
            </span>
          </div>

        </div>

        {/* ===== BACK TO TOP ===== */}
        <div className="flex justify-center mt-8">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-10 h-10 rounded-full bg-gray-800 hover:bg-zentra-600 flex items-center justify-center transition-colors duration-300 group"
            aria-label="Back to top"
          >
            <Icon
              icon="mdi:chevron-up"
              className="text-gray-400 group-hover:text-white text-xl transition-colors duration-300"
            />
          </button>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
